// noinspection JSUnusedGlobalSymbols

import { teamSlice } from './team.slice.ts';

export const { setSelectedTeamState, resetTeam } = teamSlice.actions;
